import Compressor from 'compressorjs';

const THRESHOLD = 8000000;

/**
 * Compresses an image file automatically based on its size.
 * @param {File} file - The image file to compress.
 * @returns {Promise<{base64: string, blob: Blob}>} A promise resolving to the compressed image data.
 */
export const imageAutoCompress = file => {
  return new Promise(resolve => {
    new Compressor(file, {
      quality: file.size >= THRESHOLD ? 0.3 : 0.6,
      success: blob => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function () {
          var base64data = reader.result;
          resolve({
            base64: base64data,
            blob,
          });
        };
      },
    });
  });
};

/**
 * Checks if an image exists at a given URL.
 * @param {string} url - The URL of the image to check.
 * @returns {Promise<string>} A promise resolving to the URL of the image or a fallback URL.
 */
export const imageExists = async url =>
  await fetch(url, {method: 'HEAD'})
    .then(res => {
      if (res.status === 200) {
        return url;
      } else {
        return process.env.REACT_APP_DEV_HOST + '/assets/img/advice3.png';
      }
    })
    .catch(() => {
      return process.env.REACT_APP_DEV_HOST + '/assets/img/advice3.png';
    });
